import React, { useState } from 'react';
import Parse from 'parse';
import $ from "jquery";
class UserRegistration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
        };

        this.handleRegisterSubmit = this.handleRegisterSubmit.bind(this);
    }

   
    handleRegisterSubmit(event) {
     event.preventDefault();
     var forms = document.forms.new_register_form;
     var email=forms.email.value;
     var password=forms.password.value;
     var user = new Parse.User();
     

     var getusername =  email.replace(/@.*$/,"");
     var username = getusername!==email ? getusername : null;
     user.set("username", username);
     user.set("password", password);
     user.set("email", email);
     user.set("displayName", username);
     user.set("displayUsername", username);
     user.set("isCreator", 0);
     user.set("firstName", '');
     user.set("lastName", '');
     user.set("veganSince", '');
     user.set("isAdmin", '0');
     user.set("recipeRate", '$0');
     user.set("videoRate", '');
     user.set("isBusiness", 0);
     //user.set("isCreator", 1);
     //user.set("isCreator", 1);


     user.signUp().then(function(user) {
              
        var userloggedin = Parse.User.logIn(username, password).then(function(user) {
                  console.log('user');     
                  console.log(user);                  
                  localStorage.setItem('username',user.get("username") );
                  localStorage.setItem('useremail',user.get("email") );
                  localStorage.setItem('sessionToken',user.get("sessionToken") );
                  localStorage.setItem('isLoggedin',true );
                  localStorage.setItem('ispicture_popup',true );
                 
                  window.location.href = "/";
                
                  
            }).catch(function(error){
                console.log("Error: " + error.code + " " + error.message);
            });



      }).catch(function(error){
        window.alert( error.message);
          $("form#new_register_form")[0].reset();
         
      });


    }

   

    render() {
        var result = (
            <div className="signupfrm container">
                <h4>{this.state.message}</h4>
                <form className="form-signup"  id="new_register_form" onSubmit={this.handleRegisterSubmit}>
                    <br/><br/>
                    <div className="container">
                    <h2 className="heading_logo">Joel's</h2>
        <h2 className="heading">{'Signup'}</h2>
        <div className="form_wrapper">
         <label>Email</label>
          <input type="email"
            placeholder=""
            size="large"
            name="email"
            className="form_input"
             required
          />
          <label>Password</label>
          <input
            placeholder=""
            size="large"
            type="password"
            name="password"
            className="form_input"
            required
          />
        </div>
        <div className="form_buttons"><br/><br/><br/>
        <p>By signing up, you agree to the <a href="#"><u>Terms</u></a>.</p>
          <button
            type="primary"
            className="form_button"
            color={'#208AEC'}
            size="large"
          >
            Sign Up
          </button>
          <p>or <a href="#"><u>Log In</u></a></p>
        </div>
                    <br/>
                

 </div>

                </form>
                 <h1>{this.state.text}</h1>
        <button id='handlechangeMessage'  style={{display:"none"}} onClick={this.handlechangeMessage}>Msg</button>
            </div>

        );
       
        return result;
      

    }


}

export default UserRegistration;


// WEBPACK FOOTER //
// ./src/UserRegistration.jsx